<template>
  <div id="wrap">
    <div class="dashboard clear">
      <Toolbar :menuInfo="menuInfo" :playAlarmError="playAlarmError"></Toolbar>
      <div class="right">
        <Navigation :menuInfo="menuInfo"></Navigation>
        <div class="main">
          <div class="board clear">
            <div class="incompleted-pay">
              <div class="viewer">
                <IncompletedTab
                  class="incompleted-tab"
                  :tab="tab"
                  :uID="uID"
                  :refreshEvent="refreshEvent"
                  @errorPlayAarm="errorPlayAarm"
                  @tabChange="tabChange"
                >
                </IncompletedTab>

                <IncompletedList
                  class="incompleted-list"
                  :tab="tab"
                  :uID="uID"
                  :selectedID="selectedID"
                  :refreshEvent="refreshEvent"
                  @selectPay="selectPay"
                ></IncompletedList>

                <IncompletedDetail
                  v-show="selectedID"
                  class="incompleted-detail"
                  :tab="tab"
                  :uID="uID"
                  :selectedID="selectedID"
                  @setIncompleted="setIncompleted"
                  @refresh="refresh"
                ></IncompletedDetail>

                <IncompletedConfirm
                  v-show="selectedID && incompleted"
                  class="incompleted-confirm"
                  :tab="tab"
                  :uID="uID"
                  :incompleted="incompleted"
                  @refresh="refresh"
                ></IncompletedConfirm>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-bitwise */
/* eslint-disable no-console */

import Toolbar from '@/components/include/Toolbar';
import Navigation from '@/components/include/Navigation';
import IncompletedTab from '@/components/incompletedPay/IncompletedTab';
import IncompletedList from '@/components/incompletedPay/IncompletedList';
import IncompletedDetail from '@/components/incompletedPay/IncompletedDetail';
import IncompletedConfirm from '@/components/incompletedPay/IncompletedConfirm';

export default {
  components: {
    Toolbar,
    Navigation,
    IncompletedTab,
    IncompletedList,
    IncompletedDetail,
    IncompletedConfirm,
  },
  data: () => ({
    menu: null,
    tab: 'incompleted',
    uID: null,
    selectedID: null,
    incompleted: null,
    refreshEvent: 0,
    menuInfo: {
      mainTitle: 'IncompletedPay',
      mainName: '불완전 판매 모니터링',
      subTitle: '',
      subName: '',
      company: null,
      division: null,
      device: null,
      tray: null,
      product: null,
    },
    playAlarmError: false,
  }),
  created() {
    const token = this.$jwtDecode(this.$cookie.get('accessToken'));
    this.uID = token.uID;
    this.menu = this.$route.name;
  },
  methods: {
    tabChange(tab) {
      this.tab = tab;
    },
    selectPay(ID) {
      this.selectedID = ID;
    },
    setIncompleted(incompleted) {
      this.incompleted = incompleted;
    },
    refresh() {
      this.selectedID = null;
      this.incompleted = null;
      this.refreshEvent ^= 1;
    },
    errorPlayAarm(e) {
      this.playAlarmError = e;
    },
  },
};
</script>

<style scoped>
.incompleted-pay {
  width: 100%;
}
.viewer{}
.viewer .incompleted-tab {
}
.viewer .incompleted-list {
  margin-top: 20px;
}
.viewer .incompleted-detail {
  margin-top: 48px;
}
.viewer .incompleted-confirm {
  margin-top: 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/incompletedPay/IncompletedPay.vue